export default __webpack_public_path__ + "static/media/161.9e6fc4bd.gif";